import { useCallback, useMemo, useState } from 'react';
import getMarks from '../../api/cars/getMarks';
import createMark from '../../api/cars/createMark';
import Select from '../Select/Select';
import DictionaryNameModal from '../Modal/DictionaryNameModal';
import useDictionaryCreator from './useDictionaryCreator';

/**
 * @param {boolean} used — б/у-процесс: показываем обычные марки плюс заведённые
 * под б/у, и новая марка заводится тоже под б/у.
 * @param {boolean} creatable — разрешить завести марку прямо здесь. По умолчанию
 * идёт за `used`: так было, когда заводить умел только б/у-процесс. У серых
 * дилеров (JetQ, MEGA) марки заводят и для новых авто — там `creatable` без
 * `used`, и марка попадает в обычный справочник.
 */
const SelectMarks = ({ handleSetSelect, handleSetState, style, byUser, used, creatable, ...props }) => {
  const [data, setData] = useState([]);
  const onFocus = useCallback(() => {
    getMarks({ byUser: byUser || undefined, used: used || undefined }).then((res) => {
      const marks = res.data.marks.map((item) => {
        return { value: item.id, label: item.name };
      });
      setData(marks);
    });
  }, [byUser, used]);

  const create = useCallback(async (name) => {
    // Бэк хранит марки в верхнем регистре — подписываем опцию так же, иначе
    // после перезагрузки списка выбранное значение выглядит иначе.
    const label = name.toUpperCase();
    // Марка с used=true в обычный справочник не попадает (CarsController.createMarkRequest),
    // поэтому для новых авто заводим обычную.
    const res = await createMark({ name, used: !!used });
    const id = Number(res?.data?.markId);
    if (!id) throw new Error('Не удалось добавить марку');
    return { value: id, label };
  }, [used]);

  const { extraOptions, selectProps, modalProps } = useDictionaryCreator({
    enabled: creatable ?? used,
    kind: 'mark',
    create,
    onChange: props?.onChange,
    onChangeCustom: props?.onChangeCustom,
  });

  const options = useMemo(() => [...extraOptions, ...data], [extraOptions, data]);

  return (
    <>
      <Select
        handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
        handleSetState={handleSetState}
        options={options}
        title={'Марка'}
        placeholder={'Выберите из списка'}
        onFocus={onFocus}
        style={style}
        {...props}
        {...selectProps}
      />
      {selectProps && <DictionaryNameModal {...modalProps} />}
    </>
  );
};

export default SelectMarks;
